import React, { Fragment } from 'react'
import Header from '../components/Header'
import Footer from '../components/footer';
import Newsdata from '../components/news-data';

const News = () => {
    return (<>
      <Header/>
      <div className="container my-4">
        <h2 className="section-title text-center">أخبار الموقع</h2>
        <div className="infback" style={{ borderRadius: 'var(--radius)', padding: '30px 20px' }}>
          <Newsdata />
        </div>
      </div>
    <Footer/>
    </>
    )
}

export default News
